export default {
  'Add Cut': 'أضف قص',
}